import React from 'react';
import Sidebar from '../Sidebar';
import Dashboard from '../Dashboard';
import PlanATripMain from './PlanATripMain'

export default function PlanATrip() {
    return (
        <div>
            <Dashboard cmp={<PlanATripMain />} />
        </div>
    )
}

